<template>
    <div v-redirect-if-no-permission:SERVICES>
        <DataTable ref="datatable" :url="api.ACTIONS.SERVICES" :fieldsHiddenMain='["deleted_at"]'
            :fieldsHiddenAdd='["created_at", "deleted_at", "updated_at", "id"]'
            :fieldsHiddenEdit='["created_at", "deleted_at", "updated_at", "id"]' :formatter="formatter"
            :actionsExtraMain="actionsExtraMain" :conditional-action="conditionalAction" :fields-extra-add="extraEditor"
            :fields-extra-edit="extraEditor" :input-types-add="inputTypes" :input-types-edit="inputTypes"
            :add-rules="rules(true)" :forceReload="true" :edit-rules="rules(false)" :enableDelete="false"
            :titles="titles" :title='$t("catalogPage.pageTitleServices")' />
    </div>
</template>

<script>

import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";

export default {
    components: { DataTable },
    name: "Services",
    title() {
        return this.$t("catalogPage.pageTitleServices");
    },
    methods: {
        rules(add) {
            const required = value => !!value || this.$t("catalogPage.ruleRequired");
            const number = value => {
                const pattern = /^\d+$/;
                if (!!value)
                    return pattern.test(value) || this.$t("catalogPage.ruleNumber");
                else
                    return true;
            };
            const percentage = value => {
                if (value === "" || value === null || value === undefined) return true;
                const n = Number(value);
                return (!isNaN(n) && n >= 0 && n <= 100) || this.$t("catalogPage.rulePercentage");
            };
            return {
                name_en: add ? [
                    required
                ] : [required],
                name_ar: add ? [
                    required
                ] : [required],
                info: add ? [
                    required
                ] : [required],
                icon: add ? [
                    required
                ] : [],
                priority: add ? [
                    required, number
                ] : [number],
                company_commission_percentage: [percentage],
                driver_commission_percentage: [percentage],
                owner_commission_percentage: [percentage],
            }
        },
    },
    computed: {

        extraEditor() {
            return {
                icon: 'choose-image-single',
                active: 'v-checkbox',
                is_safe_ride: 'v-checkbox'
            }
        },
        // The Safe Ride tick used to remove the service from every order form
        // while the global switch was off, with nothing on this screen saying
        // so. It is now a badge only — spell that out where it is ticked, since
        // the operator cannot see the settings page from here.
        inputTypes() {
            return {
                is_safe_ride: {
                    hint: this.$t("catalogPage.safeRideHint"),
                    "persistent-hint": true
                }
            }
        },
        formatter() {
            const api = this.api;
            const vm = this;
            return {
                icon(value) {
                    if (value == null) return vm.$t("catalogPage.unloadable");
                    if (value[0] !== '/') value = "/" + value;
                    return `<img src="${api.IMAGES_URL + value}" class="img-thumbnail"/>`;
                },
                created_at(value) {
                    return formatCompanyTime(value, "YYYY-MM-DD");
                },
                updated_at(value) {
                    return formatCompanyTime(value, "YYYY-MM-DD");
                },
                active(value) {
                    if (value == 0) {
                        return `<span style="color: red">${vm.$t("catalogPage.no")}</span>`;
                    }
                    return `<span style="color: green">${vm.$t("catalogPage.yes")}</span>`;
                },
                is_safe_ride(value) {
                    if (value == 0) return "-";
                    return `<i class="material-icons" style="color: green; font-size: 18px">videocam</i>`;
                }
            }
        },
        titles() {
            return {
                "id": "#",
                "name_en": this.$t("catalogPage.colNameEn"),
                "name_ar": this.$t("catalogPage.colNameAr"),
                "created_at": this.$t("catalogPage.colDateCreated"),
                "updated_at": this.$t("catalogPage.colLastDateUpdated"),
                "info": this.$t("catalogPage.colInfo"),
                "priority": this.$t("catalogPage.colPriority"),
                "icon": this.$t("catalogPage.colIcon"),
                "active": this.$t("catalogPage.colActive"),
                "is_safe_ride": this.$t("catalogPage.colSafeRide"),
                "company_commission_percentage": this.$t("catalogPage.colCompanyPercent"),
                "driver_commission_percentage": this.$t("catalogPage.colDriverPercent"),
                "owner_commission_percentage": this.$t("catalogPage.colOwnerPercent")
            }
        },

        conditionalAction() {
            return {
                activate(item) {
                    return !item.active;
                },
                deactivate(item) {
                    return item.active;
                }
            }
        },
        actionsExtraMain() {
            return {

                prices: {
                    icon: 'attach_money',
                    extras: {
                        color: '#85bb65'
                    },
                    action: (item) =>
                        this.$router.push({
                            name: "ServicePrices",
                            params: { "id": item.id },
                            query: { "name": item.name_en }
                        })
                },
                captains: {
                    icon: 'directions_car',
                    extras: {
                        color: 'red'
                    },
                    action: (item) =>
                        this.$router.push({
                            name: "ServiceCars",
                            params: { "id": item.id },
                            query: { "name": item.name_en }
                        })
                },
                activate: {
                    icon: 'check',
                    action: (item) => {
                        this.$dialova({
                            title: this.$t("catalogPage.activateServiceTitle"),
                            paragraph: this.$t("catalogPage.activateServiceConfirm", { name: item.name_en }),
                            loader: true,
                        })
                            .then(({ close }) => {
                                this.axios
                                    .put(`service/activate/` + item.id)
                                    .then(() => {
                                        window.getApp.$emit(
                                            "SHOW_TOAST",
                                            this.$t("catalogPage.serviceActivated"),
                                            "green"
                                        );
                                        this.$refs['datatable'].getData();
                                        close();
                                    })
                                    .catch((err) => {
                                        window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("catalogPage.errorOccurred"), "red");
                                        close();
                                    });
                            })
                            .catch(() => {
                                console.log("cancelled");
                            });
                    }
                },
                deactivate: {
                    icon: 'clear',
                    action: (item) => {
                        this.$dialova({
                            title: this.$t("catalogPage.deactivateServiceTitle"),
                            paragraph: `<p style="font-size: small;">${this.$t("catalogPage.inactiveServicesHint")}</p>` + this.$t("catalogPage.deactivateServiceConfirm", { name: item.name_en }),
                            loader: true,
                        })
                            .then(({ close }) => {
                                this.axios
                                    .put(`service/activate/` + item.id)
                                    .then(() => {
                                        window.getApp.$emit(
                                            "SHOW_TOAST",
                                            this.$t("catalogPage.serviceDeactivated"),
                                            "green"
                                        );
                                        this.$refs['datatable'].getData();
                                        close();
                                    })
                                    .catch((err) => {
                                        window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("catalogPage.errorOccurred"), "red");
                                        close();
                                    });
                            })
                            .catch(() => {
                                console.log("cancelled");
                            });
                    }
                },
                delete: {
                    icon: 'delete',
                    action: (item) => {
                        this.$dialova({
                            title: this.$t("catalogPage.deleteServiceTitle"),
                            paragraph: this.$t("catalogPage.deleteServiceConfirm", { name: item.name_en }),
                            loader: true,
                        })
                            .then(({ close }) => {
                                this.axios
                                    .delete(`service/` + item.id)
                                    .then(() => {
                                        window.getApp.$emit(
                                            "SHOW_TOAST",
                                            this.$t("catalogPage.serviceDeleted"),
                                            "green"
                                        );
                                        this.$refs['datatable'].getData();
                                        close();
                                    })
                                    .catch((err) => {
                                        window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("catalogPage.errorOccurred"), "red");
                                        close();
                                    });
                            })
                            .catch(() => {
                                console.log("cancelled");
                            });
                    }
                }
            }
        }
    }
}
</script>

<style>
.img-thumbnail {
    max-height: 40px;
    max-width: 40px;
}
</style>
